
export const user_navigation = [
    // all users
    {name: 'Profil', href: '/settings/profile'},
    {name: 'Einstellungen', href: '/settings/change-password'}
]
